import React from "react";
import Pagecomp from "./Pagecomp";
import "./Pages.css";
// import imag from "./Screenshot 2023-01-02 121950.png";
import projects from "../../../database/projects"

// console.log(projects[0].name);

function Pages() {
  return (
    <div className="pages">
      <div className="cont">
        <div className="page-head">
          <h3>Projects</h3>
        </div>
        <div className="page-grid">
          {
            projects.map((data) => <Pagecomp name={data.name} url={data.url} images={data.img} tags={data.tags} description={data.description}/>)
          
          }
          
          
        </div>
      </div>
    </div>
  );
}

export default Pages;
